import {
    onMounted, onUnmounted
} from '@vue/composition-api';
import ClipboardJS from 'clipboard';

interface useClipboardOption{
    target:string | Element | NodeListOf<Element>,
    clipboardOption?: ClipboardJS.Options,
    successCallback:() => void
    errorCallback:() => void
}
export function useClipboard(option:useClipboardOption) {
    let clipboard:ClipboardJS;
    onMounted(() => {
        clipboard = new ClipboardJS(option.target, option.clipboardOption)
            .on('success', () => {
                option.successCallback();
            }).on('error', () => {
                option.errorCallback();
            });
    });
    onUnmounted(() => {
        if (clipboard) {
            clipboard.destroy();
        }
    });
}